import { render, staticRenderFns } from "./sectionTitle.vue?vue&type=template&id=d38916f2&scoped=true&"
import script from "./sectionTitle.vue?vue&type=script&lang=js&"
export * from "./sectionTitle.vue?vue&type=script&lang=js&"
import style0 from "./sectionTitle.vue?vue&type=style&index=0&id=d38916f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38916f2",
  null
  
)

export default component.exports